// 'use client';

// import { useAuth } from '@/features/authentication/hooks/auth';
// import React, { useEffect, useState } from 'react';
// import { useForm } from 'react-hook-form';

// type ForgotPasswordInputs = {
//   email: string;
// };

// const ForgotPassword = () => {
//   const { forgotPassword } = useAuth();
//   const {
//     register,
//     handleSubmit,
//     setError,
//     formState: { errors: formErrors, isSubmitting },
//   } = useForm<ForgotPasswordInputs>();

//   const [email, setEmail] = useState('');
//   const [status, setStatus] = useState<string | null>(null);
//   const [errors, setErrors] = useState<any>([]);

//   useEffect(() => {
//     if (errors.email && errors.email.length > 0) {
//       setError('email', {
//         type: 'manual',
//         message: errors?.email[0],
//       });
//     }
//   }, [errors, setError]);

//   const onSubmit = async (data: ForgotPasswordInputs) => {
//     setEmail(data?.email);
//     forgotPassword({ email: data.email, setErrors, setStatus });
//   };

//   const resendEmail = () => {
//     forgotPassword({ email, setErrors, setStatus });
//   };

//   return (
//     <section className="account padding-top padding-bottom">
//       <div className="container">
//         <div
//           className="account__wrapper"
//           data-aos="fade-up"
//           data-aos-duration={800}
//         >
//           <div className="row justify-content-center">
//             <div className="col-lg-6">
//               <div className="account__content account__content--style1">
//                 <div className="account__header">
//                   <h2>Forget Password</h2>
//                   <p>No worries, we’ll send you reset instructions.</p>
//                 </div>
//                 {status && errors?.length < 1 ? (
//                   <button
//                     className="trk-btn trk-btn--border trk-btn--primary"
//                     onClick={resendEmail}
//                   >
//                     Resend Email Password Reset Link
//                   </button>
//                 ) : (
//                   <form
//                     onSubmit={handleSubmit(onSubmit)}
//                     className="account__form needs-validation"
//                     noValidate
//                   >
//                     <div className="row g-4">
//                       <div className="col-12">
//                         <div>
//                           <label htmlFor="account-email" className="form-label">
//                             Email
//                           </label>
//                           <input
//                             type="email"
//                             className={`form-control ${
//                               formErrors.email ? 'is-invalid' : ''
//                             }`}
//                             id="account-email"
//                             placeholder="Enter your phone number"
//                             {...register('email', {
//                               required: 'Phone number is required',
//                               pattern: {
//                                 value: /^(?:\+88|88)?01[3-9]\d{8}$/,
//                                 message: 'Invalid Bangladeshi phone number',
//                               },
//                             })}
//                           />
//                           {formErrors.email && (
//                             <div className="invalid-feedback">
//                               {formErrors.email.message}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>

//                     <button
//                       type="submit"
//                       className="trk-btn trk-btn--border trk-btn--primary d-block mt-4"
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? 'Processing...' : 'Reset password'}
//                     </button>
//                   </form>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ForgotPassword;
'use client';

import axios from '@/lib/axios';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRouter } from 'next/navigation'; // Import useRouter for redirection

// Updated interface to include all possible form fields
interface FormInputs {
  email: string;
  otp_code?: string;
  password?: string;
  password_confirmation?: string;
}

const ForgotPassword = () => {
  const router = useRouter();
  const [otpSent, setOtpSent] = useState(false);
  const [otpConfirm, setOtpConfirm] = useState(false);
  const [emailStored, setEmailStored] = useState('');
  const [otpCodeStored, setOtpCodeStored] = useState(''); // State to store the verified OTP
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const {
    register,
    handleSubmit,
    setError,
    watch, // Watch is needed for password confirmation
    formState: { errors },
  } = useForm<FormInputs>();

  const password = watch('password'); // Watch the password field for changes

  // Countdown timer effect
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [countdown]);

  const sendOTP = async (email: string) => {
    setLoading(true);
    try {
      const res = await axios.post('/api/v2/send-reset-otp', {
        email: email,
      });
      if (res.data.result) {
        setOtpSent(true);
        setEmailStored(email);
        setCountdown(120); // Start 120-second countdown
        toast.success(res.data.message || 'OTP sent successfully');
      } else {
        toast.error(res.data.message || 'Something went wrong');
      }
    } catch (error: any) {
      if (error.response?.status === 422) {
        const apiErrors = error.response.data.errors;
        Object.entries(apiErrors).forEach(([field, messages]: any) => {
          setError(field as keyof FormInputs, {
            type: 'manual',
            message: messages[0],
          });
        });
      } else {
        toast.error('Failed to send OTP. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    if (countdown > 0) return;
    await sendOTP(emailStored);
  };

  const onSubmit = async (data: FormInputs) => {
    setLoading(true);
    try {
      // Stage 1: Send OTP (if not sent yet)
      if (!otpSent) {
        await sendOTP(data.email);
        return; // Exit after sending OTP
      }

      // Stage 2: Verify OTP (if OTP is sent but not confirmed)
      if (!otpConfirm) {
        const payload = {
          email: emailStored,
          otp_code: data.otp_code,
        };
        const res = await axios.post('/api/v2/verify-reset-otp', payload);
        if (res.data.result) {
          toast.success(res.data.message || 'OTP Verified!');
          setOtpConfirm(true);
          setOtpCodeStored(data.otp_code!); // Store the verified OTP
        } else {
          toast.error(res.data.message || 'Invalid OTP.');
          setError('otp_code', {
            type: 'manual',
            message: res.data.message || 'The OTP is incorrect.',
          });
        }
        return; // Exit after verifying OTP
      }

      // Stage 3: Reset Password (if OTP is confirmed)
      if (otpConfirm) {
        const payload = {
          email: emailStored,
          otp_code: otpCodeStored,
          otp_reset: true,
          password: data.password,
        };
        const res = await axios.post(
          '/api/v2/auth/password/confirm_reset',
          payload
        );

        // Assuming a similar response structure
        if (res.data.result || res.status === 200) {
          toast.success(
            res.data.message || 'Password reset successfully! Please log in.'
          );
          setTimeout(() => router.push('/login'), 2000); // Redirect to login after 2 seconds
        } else {
          toast.error(res.data.message || 'Failed to reset password.');
        }
      }
    } catch (error: any) {
      // Generic error handling for all stages
      if (error.response?.status === 422) {
        const apiErrors = error.response.data.errors;
        Object.entries(apiErrors).forEach(([field, messages]: any) => {
          setError(field as keyof FormInputs, {
            type: 'manual',
            message: messages[0],
          });
        });
      } else {
        console.error('An error occurred:', error);
        toast.error('An unexpected error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="account padding-top padding-bottom">
      <div className="container">
        <div
          className="account__wrapper"
          data-aos="fade-up"
          data-aos-duration={800}
        >
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="account__content account__content--style1">
                <div className="account__header">
                  <h2>{otpConfirm ? 'Reset Password' : 'Forget Password'}</h2>
                  <p>
                    {otpConfirm
                      ? 'Create a new password for your account.'
                      : 'No worries, we’ll send you reset instructions.'}
                  </p>
                </div>

                {/* Single form handles all stages */}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row g-3">
                    {/* Stage 1: Email Input */}
                    {!otpSent && !otpConfirm && (
                      <div className="col-12">
                        <label htmlFor="email" className="form-label">
                          Phone
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                          id="email"
                          placeholder="Enter your phone number"
                          {...register('email', {
                            required: 'Phone number is required',
                          })}
                          disabled={loading}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">
                            {errors.email.message}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Stage 2: OTP Input */}
                    {otpSent && !otpConfirm && (
                      <div className="col-12">
                        <label htmlFor="otp_code" className="form-label">
                          OTP Code
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.otp_code ? 'is-invalid' : ''}`}
                          id="otp_code"
                          placeholder="Enter OTP"
                          {...register('otp_code', {
                            required: 'OTP is required',
                          })}
                          disabled={loading}
                        />
                        <div className="w-full d-flex justify-content-end gap-2 mt-2">
                          {countdown > 0 ? (
                            <span>
                              Resend code in{' '}
                              <span style={{ color: '#E5456D' }}>
                                {countdown}s
                              </span>
                            </span>
                          ) : (
                            <span
                              style={{ cursor: 'pointer', color: '#E5456D' }}
                              onClick={handleResendOTP}
                            >
                              Resend OTP
                            </span>
                          )}
                        </div>
                        {errors.otp_code && (
                          <div className="invalid-feedback">
                            {errors.otp_code.message}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Stage 3: New Password Input */}
                    {otpConfirm && (
                      <>
                        <div className="col-12">
                          <label htmlFor="password-new" className="form-label">
                            New Password
                          </label>
                          <input
                            type="password"
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                            id="password-new"
                            placeholder="Enter new password"
                            {...register('password', {
                              required: 'Password is required',
                              minLength: {
                                value: 6,
                                message:
                                  'Password must be at least 6 characters',
                              },
                            })}
                          />
                          {errors.password && (
                            <div className="invalid-feedback">
                              {errors.password.message}
                            </div>
                          )}
                        </div>
                        <div className="col-12">
                          <label
                            htmlFor="password-confirm"
                            className="form-label"
                          >
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                            id="password-confirm"
                            placeholder="Confirm your new password"
                            {...register('password_confirmation', {
                              required: 'Please confirm your password',
                              validate: (value) =>
                                value === password ||
                                'The passwords do not match',
                            })}
                          />
                          {errors.password_confirmation && (
                            <div className="invalid-feedback">
                              {errors.password_confirmation.message}
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {/* Submit Button */}
                    <div className="col-12">
                      <button
                        type="submit"
                        className="trk-btn trk-btn--primary d-block"
                        disabled={loading}
                      >
                        {loading
                          ? 'Please wait...'
                          : otpConfirm
                            ? 'Reset Password'
                            : otpSent
                              ? 'Verify OTP'
                              : 'Send OTP'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
